import React from 'react';
import { Gift, Brain } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'Planificador de Rendimiento Handball 12 Semanas',
  value: '$15.000',
  image: 'https://cdn.magicpatterns.com/uploads/g2LW5DgGJ9AfYHKwrMpspq/image.png'
}, {
  num: 2,
  title: 'Atlas de Ejercicios para Handball',
  value: '$12.500',
  image: 'https://cdn.magicpatterns.com/uploads/dopLQ4cHmWZ4ut6eWnvL22/image.png'
}, {
  num: 3,
  title: 'Rutinas Express para Jugadores con Poco Tiempo',
  value: '$9.900',
  image: 'https://cdn.magicpatterns.com/uploads/mHxTZus6FWxpF5Q5vTU7LW/image.png'
}, {
  num: 4,
  title: 'Psicología Deportiva: cómo enfrentar las derrotas y las victorias',
  value: '$11.000',
  image: null as string | null
}];
export function Bonuses() {
  const scrollToBuy = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 px-4 bg-brand-dark border-t border-b border-accent-base/30 relative overflow-hidden" data-id="element-14">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-accent-base/10 blur-[100px] rounded-full pointer-events-none" data-id="element-15"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-16">
        <div className="text-center mb-8" data-id="element-17">
          <span className="inline-block bg-accent-base text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-widest mb-3 animate-pulse" data-id="element-18">
            Solo por hoy
          </span>
          <h2 className="text-3xl md:text-5xl font-oswald font-bold text-white uppercase tracking-wide" data-id="element-19">
            Bonos <span className="text-accent-base" data-id="element-20">Gratis</span>
          </h2>
          <p className="text-gray-300 mt-2" data-id="element-21">
            Llevate estos complementos sin costo adicional con tu compra de hoy.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-22">
          {bonuses.map(b => <div key={b.num} onClick={scrollToBuy} className="bg-brand-light border border-accent-base/50 rounded-xl relative overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.3)] flex flex-col cursor-pointer transition-transform hover:-translate-y-1 hover:border-accent-base" data-id="element-23">
              {/* Image with gradient fade */}
              <div className="relative h-44 overflow-hidden" data-id="element-24">
                {b.image ? <img src={b.image} alt={b.title} className="w-full h-full object-cover" data-id="element-25" /> : <div className="w-full h-full bg-brand-dark flex items-center justify-center" data-id="element-26">
                    <Brain className="w-20 h-20 text-accent-base/70" strokeWidth={1.5} data-id="element-27" />
                  </div>}
                {/* Gradient overlay fading into card */}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-light/30 to-brand-light pointer-events-none" data-id="element-28"></div>
                {/* Ribbon */}
                <div className="absolute -right-10 top-4 bg-accent-base text-white text-[10px] font-bold uppercase tracking-wider py-1 px-10 rotate-45 shadow-md z-10" data-id="element-29">
                  Gratis
                </div>
              </div>

              {/* Content */}
              <div className="p-5 -mt-6 relative z-10 flex-1 flex flex-col" data-id="element-30">
                <div className="flex items-center gap-2 mb-2" data-id="element-31">
                  <div className="bg-brand-dark p-2 rounded-full border border-accent-base/30" data-id="element-32">
                    <Gift className="w-4 h-4 text-accent-base" data-id="element-33" />
                  </div>
                  <span className="text-accent-base text-xs font-bold tracking-wider uppercase" data-id="element-34">
                    Bono {b.num}
                  </span>
                </div>
                <h3 className="text-white font-medium text-base leading-tight mb-3 flex-1" data-id="element-35">
                  {b.title}
                </h3>
                <div className="flex items-center gap-2 text-sm" data-id="element-36">
                  <span className="text-gray-500 line-through" data-id="element-37">{b.value}</span>
                  <span className="text-green-400 font-bold" data-id="element-38">HOY $0</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}